import React, { useState } from 'react';

/**
 * ProgressiveImage component to eliminate Cumulative Layout Shift (CLS)
 * and provide smooth loading shimmers across the platform.
 */
export default function ProgressiveImage({
  src,
  alt = '',
  className = '',
  aspectRatio = '16/9',
  loading = 'lazy',
  decoding = 'async',
  fetchPriority = 'auto',
  style = {},
  ...props
}) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={`progressive-img-wrapper ${isLoaded ? 'is-loaded' : 'is-loading'}`}
      style={{
        position: 'relative',
        overflow: 'hidden',
        aspectRatio: aspectRatio,
        backgroundColor: '#1E293B',
        ...style
      }}
    >
      {!isLoaded && (
        <div
          className="progressive-img-skeleton"
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            background: 'linear-gradient(90deg, #1E293B 25%, #334155 50%, #1E293B 75%)',
            backgroundSize: '200% 100%',
            animation: 'progressiveShimmer 1.5s infinite linear'
          }}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding={decoding}
        fetchpriority={fetchPriority}
        onLoad={() => setIsLoaded(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: style.objectFit || 'cover',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.4s ease-in-out',
          ...style
        }}
        {...props}
      />
    </div>
  );
}
